import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_EVENTS } from "../graphql/queries";
import { Event } from "../types";

function Events() {
  const { data, loading, error } = useQuery<{ events: Event[] }>(GET_EVENTS);
  const [filter, setFilter] = useState("All");

  const eventTypes = useMemo(() => {
    const types = new Set((data?.events ?? []).map((e) => e.eventType));
    return ["All", ...Array.from(types)];
  }, [data]);

  const filtered = useMemo(() => {
    if (filter === "All") return data?.events ?? [];
    return (data?.events ?? []).filter((e) => e.eventType === filter);
  }, [data, filter]);

  if (loading) return <p className="body-text">Loading events...</p>;
  if (error) return <p className="body-text">Error: {error.message}</p>;

  return (
    <div>
      <h1 className="display-text" style={{ fontSize: 42, marginBottom: 8 }}>
        Events
      </h1>
      <p className="body-text" style={{ marginBottom: 24 }}>
        Browse our recent events and celebrations.
      </p>

      <div className="filter-bar">
        {eventTypes.map((type) => (
          <button
            key={type}
            type="button"
            className={`filter-btn ${filter === type ? "active" : ""}`}
            onClick={() => setFilter(type)}
          >
            {type}
          </button>
        ))}
      </div>

      <div className="events-grid">
        {filtered.map((event) => (
          <Link key={event.id} to={`/events/${event.id}`} className="event-card bentolio-card">
            {event.heroImageUrl && (
              <img src={event.heroImageUrl} alt={event.title} />
            )}
            <h2 className="h1-text" style={{ marginTop: 16 }}>{event.title}</h2>
            <p className="body-text">{event.eventType}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Events;
